import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';
import { UserDtoSchema } from '../contracts';

const SendUserInviteRequestDtoSchema = z.object({
  id: z.number(),
});

const SendUserInviteResponseDtoSchema = UserDtoSchema;

export type SendUserInviteRequestDto = z.infer<
  typeof SendUserInviteRequestDtoSchema
>;
export type SendUserInviteResponseDto = z.infer<
  typeof SendUserInviteResponseDtoSchema
>;

export const sendUserInvite = (
  dto: SendUserInviteRequestDto,
  config?: AxiosRequestConfig
) => {
  const data = SendUserInviteRequestDtoSchema.parse(dto);
  return api
    .post(`/users/${data.id}/invite`, {}, config)
    .then(responseContract(SendUserInviteResponseDtoSchema));
};
